// ────────────────────────────────────────
// wa-draft-ui.js — حبابِ جوابِ پیشنهادیِ AI داخلِ چتِ واتساپ
// اولین تیکه‌ی جداشده از CompanyDashboard (شروعِ شکستنِ فایلِ بزرگ)
// منطق اینجاست؛ داشبورد فقط state/draw/توابعِ API را تزریق می‌کند
// ────────────────────────────────────────

import { getChatDraft, sendDraft, sendDraftVoice, dismissDraft } from '../../core/whatsapp.js';

// escape ساده (مستقل از داشبورد)
function esc(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// از روی remoteJidِ چتِ فعال، chatId را از s.waChats پیدا کن
function activeChatId(s) {
  const chat = (s.waChats || []).find((c) => c.remoteJid === s.waActiveChat);
  return chat ? chat.id : null;
}

// ── بارگیریِ درافتِ فعالِ چت ──
// هنگامِ باز شدنِ یک چت صدا زده می‌شود
export async function loadWaDraft(ctx) {
  const { s, draw } = ctx;
  const chatId = activeChatId(s);
  if (!chatId) {
    s.waDraftData = null;
    s.waDraftText = '';
    return;
  }
  s.waDraftLoading = true;
  s.waDraftData = null;
  s.waDraftText = '';
  try {
    const res = await getChatDraft(chatId);
    s.waDraftData = res.draft || null;
    s.waDraftText = res.draft ? res.draft.suggestedReply : '';
  } catch (e) {
    s.waDraftData = null;
    s.waDraftText = '';
  } finally {
    s.waDraftLoading = false;
    draw();
  }
}

// ── ارسالِ درافت (متنِ نهاییِ ویرایش‌شده از state) ──
export async function sendWaDraft(ctx) {
  const { s, draw } = ctx;
  const draft = s.waDraftData;
  if (!draft) return;
  const text = (s.waDraftText || '').trim();
  if (!text) return;
  s.waDraftSending = true;
  draw();
  try {
    await sendDraft(draft.id, text);
    // درافت رفت → پاکش کن و پیام‌ها را تازه کن
    s.waDraftData = null;
    s.waDraftText = '';
    if (ctx.reloadMessages) await ctx.reloadMessages();
  } catch (e) {
    s.waDraftErr = 'ارسال نشد.';
  } finally {
    s.waDraftSending = false;
    draw();
  }
}

// ── ارسالِ درافت به‌صورتِ صوتی (متن → صوت) ──
export async function sendWaDraftVoice(ctx) {
  const { s, draw } = ctx;
  const draft = s.waDraftData;
  if (!draft) return;
  const text = (s.waDraftText || '').trim();
  if (!text) return;
  s.waDraftSending = true;
  draw();
  try {
    await sendDraftVoice(draft.id, text);
    s.waDraftData = null;
    s.waDraftText = '';
    if (ctx.reloadMessages) await ctx.reloadMessages();
  } catch (e) {
    s.waDraftErr = 'ارسالِ صوتی نشد.';
  } finally {
    s.waDraftSending = false;
    draw();
  }
}

// ── رد کردنِ درافت ──
export async function dismissWaDraft(ctx) {
  const { s, draw } = ctx;
  const draft = s.waDraftData;
  if (!draft) return;
  try {
    await dismissDraft(draft.id);
  } catch (e) {
    // حتی اگر خطا داد، از UI برش می‌داریم
  }
  s.waDraftData = null;
  s.waDraftText = '';
  draw();
}

// ── رندرِ حبابِ درافت (HTML) ──
// اگر درافتی نباشد، رشته‌ی خالی برمی‌گرداند
export function renderWaDraft(s) {
  if (s.waDraftLoading) {
    return '<div class="cd-wa-draft cd-wa-draft-loading">…</div>';
  }
  const d = s.waDraftData;
  if (!d) return '';

  const warn = d.needsManager
    ? '<div class="cd-wa-draft-warn">⚠️ Preis/Termin – bitte prüfen</div>'
    : '';

  const sending = s.waDraftSending;

  return (
    '<div class="cd-wa-draft">' +
    '<div class="cd-wa-draft-label">🤖 KI-Vorschlag</div>' +
    warn +
    '<textarea class="cd-wa-draft-text" id="cd-wa-draft-text" ' +
    (sending ? 'disabled ' : '') +
    'rows="3">' + esc(s.waDraftText) + '</textarea>' +
    '<div class="cd-wa-draft-actions">' +
    '<button class="cd-wa-draft-dismiss" data-action="wa-draft-dismiss"' +
    (sending ? ' disabled' : '') + '>Verwerfen</button>' +
    '<button class="cd-wa-draft-voice" data-action="wa-draft-send-voice"' +
    (sending ? ' disabled' : '') + ' title="Als Sprachnachricht senden">' +
    (sending ? '…' : '🎤') + '</button>' +
    '<button class="cd-wa-draft-send" data-action="wa-draft-send"' +
    (sending ? ' disabled' : '') + '>' +
    (sending ? '…' : 'Senden') + '</button>' +
    '</div>' +
    '</div>'
  );
}
